// extracted by mini-css-extract-plugin
export default {"wrapper":"Dropzone_wrapper__1krYW","attachButton":"Dropzone_attachButton__FniAe","ring":"Dropzone_ring__65JZt"};